import { hasUserRole } from '.';

export function isOrgAdmin(user, groupId) {
  return hasUserRole({
    groupId,
    name: 'Org Admin',
    roleType: 'primary',
    user,
  });
}

export default isOrgAdmin;
